import React, { useEffect } from "react";
import Styles from "./Layout.module.css";
import BgEllipse from "../common/BgEllipse";
import MainHeader from "../common/MainHeader";
import Login from "./Login";
import AuthRedirect from "./AuthRedirect";
import SigningIn from "./SigningIn";
import SlackConnect from "./SlackConnect/SlackConnect";
import WelcomePage from "./WelcomePage/WelcomePage";
import Launch from "./LaunchPage/Launch";
import bg_big_logo from "../../assets/images/bg_images/bg_big_logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import utils from "../../utils";
import ForgetPassword from "./ForgetPassword/ForgetPassword";
function Layout(props) {
  let location = useLocation();
  let navigate = useNavigate();
  useEffect(() => {
    if (location?.pathname)
      document.title = utils.capitalize(location.pathname.split("/")[1]);
  }, [location.pathname]);

  useEffect(() => {
    if (props.page == "login" || props.page == "authRedirect") {
      if (
        utils.fetchVariable("botza_token") &&
        utils.fetchVariable("current_team")
      ) {
        navigate("/dashboard");
      }
    }
  }, [props.page]);
  
  function renderUi() {
    switch (props.page) {
      case "login":
        return <Login />;
        break;
      case "welcome":
        return <WelcomePage />;
        break;
      case "connect":
        return <SlackConnect />;
        break;
      case "launch":
        return <Launch />;
        break;
      case "authRedirect":
        return <AuthRedirect />;
        break;
      case "forgetPassword":
        return <ForgetPassword />;
        break;
      default:
        return <Login />;
    }
  }
  return (
    <div className={Styles.layoutContainer}>
      <MainHeader activePage={props.page} />
      <BgEllipse />
      <img
        src={bg_big_logo}
        alt="big_big_logo"
        className={Styles.layoutContainer__bigLogo}
      />
      <div className={Styles.layoutMain}>{renderUi()}</div>
    </div>
  );
}

export default Layout;
